import { FormBase } from 'core/components';

export default class NikoFacilityOrderReasonForChangeModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'note',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.NOTE_PLACEHOLDER',
                    rules: 'string'           
                },
                {
                    name: 'effectiveDate',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.EFFECTIVE_DATE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.EFFECTIVE_DATE_PLACEHOLDER',
                },
                {
                    name: 'eligibilityStatusId',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.INSURANCE_STATUS_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.INSURANCE_STATUS_PLACEHOLDER',
                    rules: 'required'  
                }              
            ],
        };
    }
}
